import React, { useMemo } from "react";
import { Radio } from "antd";
import { RadioGroupProps } from "antd/lib/radio";
import { RadioButtonProps } from "antd/lib/radio/radioButton";
import { RadioProps } from "antd/es/radio";

export interface IProps extends RadioGroupProps {
  data?: any[];
  getValue?: (item: any) => string | number;
  getDisplayText?: (item: any) => string | number;
  itemProps?: RadioButtonProps | RadioProps;
  itemType?: "button" | "radio";
}

const defaultGetValue = (item: any) => item.value;

const defaultGetDisplayText = (item: any) => item.name;

const RadioGroup = (props: IProps) => {
  const {
    data = [],
    getValue = defaultGetValue,
    getDisplayText = defaultGetDisplayText,
    itemProps,
    itemType = "button",
    ...rest
  } = props;

  const ItemComponent = useMemo(
    () => (itemType === "button" ? Radio.Button : Radio),
    [itemType]
  );

  return (
    <Radio.Group {...rest}>
      {data.map((item: any) => {
        const value = getValue(item);
        return (
          <ItemComponent value={value} key={value} {...itemProps}>
            {getDisplayText(item)}
          </ItemComponent>
        );
      })}
    </Radio.Group>
  );
};

export default RadioGroup;
